"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var LogoText = _styledComponents["default"].div.attrs(function () {
  return {
    className: "ml-2"
  };
}).withConfig({
  displayName: "NavigationLogo__LogoText",
  componentId: "sc-4dhff-0"
})(["&&&{font-size:1.3125rem;font-weight:500;font-family:\"Roboto\",sans-serif;color:", ";}"], function (props) {
  return props.theme["white"];
});
var LogoHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center"
  };
}).withConfig({
  displayName: "NavigationLogo__LogoHolder",
  componentId: "sc-4dhff-1"
})(["@media (max-width:767px){height:", ";}@media (min-width:768px){height:", ";}"], function (props) {
  return props.styles.mobileHeight;
}, function (props) {
  return props.styles.height;
});
var NavLogo = _styledComponents["default"].img.attrs(function () {
  return {
    alt: "Logo"
  };
}).withConfig({
  displayName: "NavigationLogo__NavLogo",
  componentId: "sc-4dhff-2"
})(["@media (max-width:767px){height:", ";}@media (min-width:768px){height:", ";}"], function (props) {
  return props.styles.mobileHeight;
}, function (props) {
  return props.styles.height;
});
var NavigationLogo = function NavigationLogo(_ref) {
  var logo = _ref.logo,
    logoText = _ref.logoText,
    builds = _ref.builds,
    children = _ref.children,
    styles = _ref.styles,
    rest = _objectWithoutProperties(_ref, ["logo", "logoText", "builds", "children", "styles"]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipOpen = _useState2[0],
    setTooltipOpen = _useState2[1];
  var toggle = function toggle() {
    setTooltipOpen(!tooltipOpen);
  };
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    id: "TooltipTarget"
  }, logoText && logoText.length ? _react["default"].createElement(LogoHolder, _extends({
    styles: styles
  }, rest), _react["default"].createElement(_Icon["default"], {
    styles: {
      color: "white",
      hoverColor: "white"
    },
    iconName: "fa-baseball-ball"
  }), _react["default"].createElement(LogoText, null, logoText)) : _react["default"].createElement(NavLogo, _extends({
    src: logo,
    href: "#",
    styles: styles
  }, rest)), children), builds.length ? _react["default"].createElement(_reactstrap.Tooltip, {
    placement: "bottom",
    isOpen: tooltipOpen,
    target: "TooltipTarget",
    toggle: toggle,
    delay: {
      show: 1000,
      hide: 500
    }
  }, _react["default"].createElement("div", {
    className: "p-1"
  }, _react["default"].createElement("div", null, "Versions"), _react["default"].createElement("div", null, builds.map(function (b) {
    return _react["default"].createElement("div", {
      key: b.name
    }, b.name, ": ", b.build);
  })))) : null);
};
NavigationLogo.propTypes = {
  logo: _propTypes["default"].any.isRequired,
  height: _propTypes["default"].number,
  logoText: _propTypes["default"].string,
  builds: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    build: _propTypes["default"].string.isRequired
  })),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  styles: _propTypes["default"].shape({
    height: _propTypes["default"].string,
    mobileHeight: _propTypes["default"].string
  })
};
NavigationLogo.defaultProps = {
  logoText: "",
  builds: [],
  children: null,
  height: 40,
  styles: {
    height: "40px",
    mobileHeight: "26px"
  }
};
var _default = NavigationLogo;
exports["default"] = _default;